import { Box, styled } from "@mui/system";

export const TabBar = styled('div')(() => ({
    width: 60,
    backgroundColor: '#6e6e6e',
    borderRight: '1px solid black',
}));

// This would represent the tab bar container styling
export const DialogTabBarContainer = styled('div')(({ theme }) => ({
    width: 60,
    height: '100%',
    paddingTop: '20px',
    backgroundColor: theme.palette.primary.main,
    '& .tabbarHolder': {
        display: 'flex',
        height: '100%',
    },
}));

export const DialogOverlay = styled('div')(() => ({
    zIndex: 600,
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const PreviewImgContainer = styled(Box)(() => ({
    height: 80,
    margin: 'auto',
    position: 'relative',
    '& img': {
        borderStyle: 'none',
        padding: 0,
        maxWidth: 300,
        maxHeight: 80,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 'auto',
    },
    marginBottom: '5px'
}));

// Styled containers, mimicking the Aurelia classes
export const MainDialogContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'stretch',
    alignContent: 'stretch',
}));
